import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Button, Icon, Grid, Header } from 'semantic-ui-react';
import { CalendarPicker } from 'Common/Components/DatePicker/DatePicker';

import { SecurityPreferences } from 'Common/Security/SecurityPreferences';
import { PreferencesEnum } from 'Common/Security/PreferencesEnum';
import Modal from 'PointOfSale/modules/common/component/Modal';
import SetDateSiteHeader from 'PointOfSale/modules/setDateAndSite/component/SetDateSiteHeader';

const SetDateAndSite = props => {
  const {
    open,
    handleSiteNameChange,
    servingSites = [],
    saveSiteAndDate,
    handleCalendarChange,
    siteDate,
    selectedSite,
    closeModal,
  } = props;
  const header = <SetDateSiteHeader onClose={closeModal} />;
  const actions = [
    <Button key={'done'} size="large" primary>
      <Button.Content>
        Continue <Icon name={'forward'} />
      </Button.Content>
    </Button>,
  ];
  return (
    open && (
      <Modal
        key="sessionModal"
        open={open}
        size={'small'}
        onClose={closeModal}
        header={header}
        actions={actions}
        footerAction={saveSiteAndDate}
        closeOnDimmerClick={false}
        actionClassName="modal-action site-modal-action"
      >
        <Grid>
          <Grid.Column width="8">
            <Header as="h4" className="text-orange" textAlign="center">
              Set Date
            </Header>
            <SecurityPreferences scope={PreferencesEnum.CanChangeServingDate}>
              {disabled => (
                <CalendarPicker
                  fluid
                  useMoment
                  value={siteDate}
                  disabled={disabled}
                  className="site-date-picker"
                  onChange={handleCalendarChange}
                />
              )}
            </SecurityPreferences>
          </Grid.Column>
          <Grid.Column width="8">
            <Header as="h4" className="text-orange" textAlign="center">
              Set Site
            </Header>
            <Dropdown
              fluid
              className="servingOpton-dropdown"
              placeholder="Please select a site"
              selection
              options={servingSites}
              size="large"
              value={selectedSite}
              onChange={handleSiteNameChange}
            />
          </Grid.Column>
        </Grid>
      </Modal>
    )
  );
};

SetDateAndSite.propTypes = {
  onClose: PropTypes.func,
  header: PropTypes.func,
  actions: PropTypes.array,
  actionClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  siteDate: PropTypes.object,
  selectedSiteDetails: PropTypes.object,
  handleCalenderChange: PropTypes.func,
  closeModal: PropTypes.func,
  handleSiteNameChange: PropTypes.func,
};

export default SetDateAndSite;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/setDateAndSite/component/index.js